import _styled from "styled-components";
var _excluded = ["style", "className", "children", "size", "type"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { stylePropType } from '@adsk/alloy-helpers';
import { ICON_ALIAS_TYPES, ICON_TYPES, ICONS } from './consts';

/**
 * A component for rendering single color icons as inline SVGs.
 */
var Icon = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var style = _ref.style,
      className = _ref.className,
      children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, _excluded);

  var aliasType = type && ICON_ALIAS_TYPES[type];
  useEffect(function () {
    if (aliasType) {
      console.warn("Icon type \"".concat(type, "\" is deprecated, please update to type, \"").concat(aliasType, "\"."));
    }
  }, [type, aliasType]);
  var finalType = aliasType || type;
  return /*#__PURE__*/React.createElement(_StyledSvg, _extends({
    ref: ref,
    height: size,
    width: size,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    className: className,
    "data-testid": type
  }, props, {
    $_css: style ? [style] : undefined
  }), children ? children : /*#__PURE__*/React.createElement("path", {
    d: ICONS[finalType],
    fill: "currentColor"
  }));
});
Icon.displayName = 'Icon';
Icon.defaultProps = {
  size: 24
};
Icon.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,

  /** Class applied to the root element */
  className: PropTypes.string,

  /** Icon content, if rendering a custom SVG not listed in included types */
  children: PropTypes.node,

  /** Square size of icon (in pixels, defaults to 24) */
  size: PropTypes.number,

  /** Icon type */
  type: PropTypes.oneOf(Object.values(ICON_TYPES))
};
export default Object.assign(Icon, {
  TYPES: ICON_TYPES
});

var _StyledSvg = _styled("svg").withConfig({
  displayName: "Icon___StyledSvg",
  componentId: "sc-1f0gmd8-0"
})(["", ""], function (p) {
  return p.$_css;
});
//# sourceMappingURL=Icon.js.map